import { addSlashes } from 'utils/cms/utils';
import { OVERRIDE } from 'utils/dynamicData';

function mapCreditList(credits) {
	if (!credits) return null;
	if (typeof credits !== 'object') return credits;
	return Object.values(credits || {})
		.sort((a, b) => (a.order || 99) - (b.order || 99))
		.map(item => item.name)
		.join('\n');

}

function mapCredits(cmsData) {
	const creditsData = cmsData?.pages?.synopsis?.credits;
	if (!creditsData) return null;

	const result = {};
	result[OVERRIDE] = true; // Ensure that all credits are overridden
	for (const [key, section] of Object.entries(creditsData)) {
		const names = mapCreditList(section?.credits);
		if (!names) continue;
		result[key] = {
			heading: section?.label || section?.sectionTitle,
			names,
			order: section?.order,
		};
	}

	return Object.keys(result).length ? result : null;
}

export default function mapSynopsis(cmsData, appData) {
	if (!appData?.pages?.boltSynopsis) return null;

	const synopsisData = cmsData?.pages?.synopsis;
	if (!synopsisData?.active) return null;

	const credits = mapCredits(cmsData);
	const onesheetData = synopsisData?.onesheet?.custom ? synopsisData.onesheet : cmsData?.onesheet;

	return {
		disabled: false,
		data: {
			content: synopsisData.synopsis,
			credits: credits,
			onesheet: onesheetData?.url,
			onesheetAltText: onesheetData?.alt,
			tagline: synopsisData.tagline,
		},
		name: synopsisData.name,
		order: cmsData.pages.home?.sections?.synopsis?.order ?? synopsisData.order,
		path: addSlashes(synopsisData.path),
	};
}